import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";

export default function TitleBar() {
  return (
    <Paper
      elevation={5}
      sx={{
        width: "100%",
      }}
    >
      <Typography
        variant="body2"
        align="center"
        sx={{
          my: "10px",
        }}
      >
        FINANCIAL ANALYSIS - VERSION 1.0.16
      </Typography>

      {/* <Box
        sx={{
          my: "10px",
          display: "flex",
          flexDirection: "row",
          border: "1px dotted blue",
        }}
      >
        <Typography
          variant="body2"
          align="center"
          sx={{
            my: "10px",
          }}
        >
          FINANCIAL ANALYSIS - VERSION 1.0.0
        </Typography>
      </Box> */}
    </Paper>
  );
}
